module.exports = __webpack_public_path__ + "static/media/typeahead_design.f5f343a0.png";